export default __webpack_public_path__ + "static/media/sv_15.bccdcf67.webp";